module.exports = __webpack_public_path__ + "static/media/ClarikaOfficeGeo-Rg.cc2eac4b.woff2";